import { render } from "./SetDefault.vue?vue&type=template&id=7556168a&scoped=true"
import script from "./SetDefault.vue?vue&type=script&lang=js"
export * from "./SetDefault.vue?vue&type=script&lang=js"

import "./SetDefault.vue?vue&type=style&index=0&id=7556168a&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7556168a"]])

export default __exports__